const API_URL: string = import.meta.env.VITE_API_URL
const CABLE_URL: string = import.meta.env.VITE_CABLE_URL
const ENVNAME: string = import.meta.env.VITE_ENVNAME
const BUGSNAG_API_KEY: string = import.meta.env.VITE_BUGSNAG_API_KEY

export { API_URL, BUGSNAG_API_KEY, CABLE_URL, ENVNAME }
